import {useSelector, useDispatch} from 'react-redux';
import {I18n} from 'react-redux-i18n';

import {useLocation} from 'react-router-dom';
import appConfig from '../../../config';

import {recordGAEvent} from '../../utils/analytics';
import {toggleDiscoverBdrBox} from '../../actions/display';

import utils from './utils';
import {pathResolver} from '../../utils/basePathHelper';

function ToggleBdrBoxButton() {
  const [organisation = {}, bdrServiceAuthorized, isBoxShown] = useSelector(state => {
    const {organisationId} = state.organisation;
    const bdr = state.subscriptions?.[organisationId]?.bdrServiceAuthorized;
    const {showDiscoverBdrBox = true} = state.display?.[organisationId] || {};
    return [state.organisation, bdr, showDiscoverBdrBox];
  });
  const dispatch = useDispatch();
  const location = useLocation();

  function gaEventToggleBox() {
    const path = location.pathname;
    recordGAEvent('BdR', `${isBoxShown ? 'Hide from icon' : 'Show'} discover Bdr box on ${path}`);
  }

  if (
    !appConfig?.featureFlags?.showAccessBdrButton ||
    !utils.shouldDisplay(bdrServiceAuthorized, organisation, location.pathname)
  ) {
    return null;
  }

  return (
    <button
      onClick={() => {
        dispatch(toggleDiscoverBdrBox(organisation.organisationId));
        gaEventToggleBox();
      }}
      className="button-square flex-container mr-3 justify-content-center"
      title={I18n.t('menu.bdr')}
      style={{backgroundColor: '#3B2D6D', borderRadius: 12, width: '45px', height: '40px'}}
    >
      <img
        alt="icon bdr"
        src={pathResolver('resources/img/icon_bdr.png')}
        style={{width: '30px'}}
      />
    </button>
  );
}

export default ToggleBdrBoxButton;
